import { useQuery } from "@tanstack/react-query";
import { getStudyGroupUnreadCounts } from "@/lib/humhub-api/studyGroups";
import type { StudyGroupUnreadTotals } from "@/lib/humhub-api/types";
import {
  MY_STUDY_GROUPS_STALE_TIME_MS,
  studyGroupKeys,
} from "@/lib/queryKeys/studyGroupKeys";
import { EMPTY_STUDY_GROUP_UNREAD_TOTALS } from "@/lib/studyGroupUnread";

export const useStudyGroupUnreadCounts = () => {
  const unreadCountsQuery = useQuery({
    queryKey: studyGroupKeys.myStudyGroupsUnreadTotals(),
    queryFn: getStudyGroupUnreadCounts,
    staleTime: MY_STUDY_GROUPS_STALE_TIME_MS,
  });

  const refreshUnreadCounts = async (): Promise<StudyGroupUnreadTotals> => {
    const result = await unreadCountsQuery.refetch({ throwOnError: true });
    return result.data ?? EMPTY_STUDY_GROUP_UNREAD_TOTALS;
  };

  return {
    totalUnreadCounts:
      unreadCountsQuery.data ?? EMPTY_STUDY_GROUP_UNREAD_TOTALS,
    refreshUnreadCounts,
  };
};
